import { useQuery } from 'react-query';
import { TransactionService } from '@wealthlane/api-services/wealthlane-award-service';
import { convertNumberWithCommas } from '../../utils/global';

const useGetTransactionHistoryTaxDetail = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string,
  setInitialValue?: any
) => {
  const transactionHistoryTaxDetail = useQuery(
    ['getTransactionHistoryTaxDetail', id],
    async () => {
      if (id) {
        return await handleRequest(
          TransactionService.getApiAwardApiAppTransactionTaxDetailsByTransactionId(id)
        );
      }
    },
    {
      onSuccess: (response: any) => {
        if (response != null && setInitialValue) {
          const formattedTaxDetails = {
            ...response,
            taxDetails: response?.taxDetails?.map((taxDetail: any) => ({
              ...taxDetail,
              taxRate: convertNumberWithCommas(Number(taxDetail.taxRate).toFixed(4), true),
              taxAmount: convertNumberWithCommas(Number(taxDetail.taxAmount).toFixed(4), true),
            })),
          };

          setInitialValue(formattedTaxDetails);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
  return transactionHistoryTaxDetail;
};

export default useGetTransactionHistoryTaxDetail;
